import "./header.css";
import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { HeaderLinksDesktop } from "./links";
import CotownLogo from "../../../assets/images/CoTownLogo.webp";
import Hamburger from "../../Hamburger/Hamburger";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../../LanguageSwitcher/LanguageSwitcher";
import { useEffect, useState } from "react";
import { OnboardingEmitter } from "../../../misc/onboardingEmitter";

  const Header = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [hasOnboardingBtn, setHasOnboardingBtn] = useState(false);
  
  useEffect(() => {
    if (location.pathname.includes('/create-design')) {
      setHasOnboardingBtn(true);
    } else {
      setHasOnboardingBtn(false);
    }
  }, [location?.pathname]);

  const hideOnboardingBtn = (event) => {
    if (event) {
      setHasOnboardingBtn(false);
    }
  }

  const showOnboardingBtn = (event) => {
    if (event) {
      setHasOnboardingBtn(true);
    }
  }

  useEffect(() => {
    OnboardingEmitter.subscribe('hideOnboarding', (event) => hideOnboardingBtn(event));
    // OnboardingEmitter.subscribe('startOnboarding', (event) => console.log('start onboardingprocess', event));
    OnboardingEmitter.subscribe('showOnboarding', (event) => showOnboardingBtn(event));
    return () => OnboardingEmitter.unsubscribe();
  }, [OnboardingEmitter])

  const startOnboarding = () => {
    OnboardingEmitter.dispatch('startOnboarding', true);
  }

  return (
    <div className="header_wrapper">
      <header className="header">
        <div className="navigation_wrapper">
          <nav className="navigation_desktop">
            <Hamburger  />
            <div className="nav_left">
              <a className="logo" href="/app">
                <img className="logo" src={CotownLogo} />
              </a>
              <div className="links_holder">
                {HeaderLinksDesktop.map((link, index) => {
                  return (
                    <div key={index} className="link_wrapper">
                      {link.icon}
                      <Link
                        key={index}
                        className="navigation_links"
                        to={link.link}
                      >
                        {t(`${link.title}`)}
                      </Link>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="nav_right">
              <button style={{display: hasOnboardingBtn ? 'block' : 'none'}} className="onboarding-btn" onClick={startOnboarding}>Start tutorial</button>
              <div style={{display: hasOnboardingBtn && window.innerWidth >= 1100 ? 'block' : 'none'}} className="vertical_line"></div>
              <div style={{display: window.innerWidth < 1100 ? 'none' : 'block'}} className="lang_switcher_desktop">
                <LanguageSwitcher></LanguageSwitcher>
              </div>
            </div>
          </nav>
        </div>
      </header>
    </div>
  );
};

export default Header;
